import { gql } from '@apollo/client'
import fullObjectivePaymentFragment from './fullObjectivePayment.fragment'

export const CreateOrUpdateObjectivePayment = gql`
  mutation createOrUpdateObjectivePayment($objectivePayment: ObjectivePaymentInput!) {
    createOrUpdateObjectivePayment(objectivePayment: $objectivePayment) {
      ...FullObjectivePayment
    }
  }
  ${fullObjectivePaymentFragment}
`

export default {
  CreateOrUpdateObjectivePayment,
}
